const isJSON = (str: string): boolean => {
  if (typeof str !== "string") {
    return false;
  }
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
};

export const getRidOfJSON = (jsonObject: any) => {
  if (typeof jsonObject === "string") {
    while (isJSON(jsonObject)) {
      if (jsonObject === null) {
        return jsonObject;
      }

      jsonObject = JSON.parse(jsonObject);
    }
  }
  return jsonObject;
};
